<template>
  <!-- <v-carousel :show-arrows="false" height="350">
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="getImage('/' + item.cover_url)"
      ></v-carousel-item>
    </v-carousel> -->

  <v-card v-if="product.slug" class="mx-auto my-12" max-width="400">
    <v-skeleton-loader v-if="imageLoad" type="card-avatar"></v-skeleton-loader>
    <v-img :src="getImage('/' + product.cover)" class="red--text" v-show="!imageLoad">
    </v-img>
    <v-card-text length="10" style="height: 80px; overflow: hidden">
      {{ product.title }}</v-card-text
    >

    <v-card-text>
      <v-simple-table dense>
        <tbody>
          <tr>
            <td><v-icon>mdi-weight</v-icon> Weight</td>
            <td>{{ product.weight }} gr</td>
          </tr>
          <tr>
            <td><v-icon>mdi-format-list-bulleted</v-icon> Stock</td>
            <td>{{ product.stock }} item</td>
          </tr>
          <tr>
            <td><v-icon>mdi-eye</v-icon> Views</td>
            <td>{{ product.views }}</td>
          </tr>
          <tr>
            <td><v-icon>mdi-shopping-outline</v-icon> Sold</td>
            <td v-if="product.sold != null">{{ product.sold }}</td>
            <td v-else>0</td>
          </tr>
          <tr>
            <td><v-icon>mdi-cash</v-icon> Price</td>
            <td class="black--text">
              Rp {{ parseInt(product.price).toLocaleString("id-ID") }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      Description: <br />
      {{ product.description }}
      <br />
      Categories:
      <v-chip
        v-for="category in product.categories"
        :key="category.id"
        :to="'/category/' + category.slug"
        small
        color="#1B5E20"
        class="white--text"
      >
        {{ category.name }}
      </v-chip>
    </v-card-text>
    <v-card-actions>
      <v-btn
        block
        color="#1B5E20"
        @click="buy"
        :disabled="product.stock == 0"
        rounded
        outlined
        elevation="5"
        large
      >
        <v-icon>mdi-cart-plus</v-icon> &nbsp; BUY
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    product: {},
    items: [],
    products_promotions: [],
    imageLoad: true,
  }),
  created() {
    this.promotion(), this.product_slider();
  },
  computed: {
    ...mapGetters({
      carts: "cart/carts",
    }),
  },
  methods: {
    ...mapActions({
      addCart: "cart/add",
      setAlert: "alert/set",
    }),
    buy() {
      this.addCart(this.product);
      this.setAlert({
        status: true,
        color: "success",
        text: "Added to cart",
      });
    },
    go() {
      let { slug } = this.$route.params;
      let url = "/ecommerce-products/slug/" + slug;
      url = url + "?page=" + this.page;
      url = encodeURI(url);
      this.axios
        .get(url)
        .then((response) => {
          let { data } = response.data;
          this.product = data;
          Array.from(this.products_promotions).forEach((element) => {
            if (element.id == this.product.id) {
              this.product.price = element.price;
            }
          });
          this.imageLoad = false;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    product_slider() {
      let { slug } = this.$route.params;
      let url = "/product/slider/" + slug;
      url = url + "?page=" + this.page;
      url = encodeURI(url);
      this.axios
        .get(url)
        .then((response) => {
          let { data } = response.data;
          this.items = data;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    promotion() {
      let url = "/products-eccomerce";
      this.axios
        .get(url)
        .then((response) => {
          let { data } = response.data;
          this.products_promotions = data;
          Array.from(this.products_promotions).forEach(
            (element) => (element.priceTmp = element.price)
          );
          Array.from(this.products_promotions).forEach(
            (element) =>
              (element.price = parseInt(
                element.price - element.price * (element.result / 100)
              ))
          );
          this.go();
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
  },
};
</script>
